import { ReactNode, useEffect, useRef } from 'react';

import { keepTimesWhole } from '../messages';
import { ErrorPanel } from '../Operations.styles';

type Props = {
  messages: string[];
  testId: string;
  /** e.g. a Reload link under the lines. */
  children?: ReactNode;
  /**
   * Take focus when shown. The failed request disabled the control
   * that had focus, and the browser dropped it to <body>.
   */
  focusOnShow?: boolean;
};

/** Inline server errors: one line per message, announced on change. */
const ErrorList = ({ messages, testId, children, focusOnShow }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (focusOnShow) ref.current?.focus({ preventScroll: true });
  }, [focusOnShow, messages]);

  return (
    <ErrorPanel
      ref={ref}
      role="alert"
      tabIndex={focusOnShow ? -1 : undefined}
      data-testid={testId}
    >
      <ul>
        {messages.map((message, i) => (
          // Messages can repeat (one per date); the index keeps keys unique.
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${i}-${message}`}>{keepTimesWhole(message)}</li>
        ))}
      </ul>
      {children}
    </ErrorPanel>
  );
};

export default ErrorList;
